module.exports = __webpack_public_path__ + "img/jyoti_sing.bd761f52.png";